// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".A4VDn {\n  background-color: var(--color-gray);\n}\n\n.sodha,\n.A4VDn,\n.AgTYg {\n  width: var(--schoolinks-icon-xl);\n  height: var(--schoolinks-icon-xl);\n}\n\n.AgTYg {\n  background-color: var(--color-blue-xtra-dark);\n  border-radius: 50%;\n  padding: var(--spacing-xs);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"greyAvatar": "A4VDn",
	"icon": "sodha",
	"iconContainer": "AgTYg"
};
export default ___CSS_LOADER_EXPORT___;
